import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { UntilDestroy, UntilDestroyed } from '@app/shared/utils/until-destroy';
import { DropdownItem } from '@voyagu/radar-design-system';
import { startWith } from 'rxjs/operators';
import { FormlyTypeaheadV2Component } from '../typeahead-v2/formly-typeahead-v2.component';

@UntilDestroy()
@Component({
  selector: 'thread-select',
  templateUrl: './thread-select.component.html',
  styleUrls: ['./thread-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreadSelectComponent extends FormlyTypeaheadV2Component implements OnInit {
  cdRef = inject(ChangeDetectorRef);

  ngOnInit() {
    super.ngOnInit();

    this.formControl.valueChanges
      .pipe(startWith(this.formControl.value), UntilDestroyed(this))
      .subscribe((value) => {
        this.syncSelectedItem(value);
        this.cdRef.markForCheck();
      });
  }

  syncSelectedItem(value: unknown) {
    if (!value || typeof value !== 'object' || !('value' in (value as DropdownItem))) {
      this.selectedItem = null;
      return;
    }

    this.selectedItem = value as DropdownItem;
  }
}
